import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getMessages = async () => {
  const response = await axios.get(`${getAPIService}/msg-files`)
  return response.data
}
